import { ResizeHandler } from '../../_modules/resize_handler/resize_handler';
import Swiper from 'swiper';

export const initializeRotatingBannerSlider = () => {
  const slides = $('.rotating-banner-slider .swiper-slide');

  if ((slides.length > 1 && window.innerWidth < 1200) || (slides.length > 4 && window.innerWidth >= 1200)) {
    new Swiper('.rotating-banner-slider', {
      centeredSlides: true,
      loop: true,
      slidesPerView: window.innerWidth < 1200 ? 1 : 4,
      autoplayDisableOnInteraction: false,
      autoplay: 4000,
    });

    ResizeHandler.subscribe(() => $('.slider__slide').eqHeight());
    $('.slider__slide').eqHeight();
  }
};
